import { render, staticRenderFns } from "./ComparativePreviousTournaments.vue?vue&type=template&id=2d1b576c&scoped=true&"
import script from "./ComparativePreviousTournaments.vue?vue&type=script&lang=js&"
export * from "./ComparativePreviousTournaments.vue?vue&type=script&lang=js&"
import style0 from "./ComparativePreviousTournaments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ComparativePreviousTournaments.vue?vue&type=style&index=1&id=2d1b576c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b576c",
  null
  
)

export default component.exports